import React from "react";
import styled from "styled-components";

const StyledHeader = styled.header`
  width: 80%;
  margin: auto;
  padding: 5vh 3vw;
  background-color: #84A3BC;
  color: #ffffff;
`;

const StyledMain = styled.main`
    width:80%;
    margin:auto;
    padding: 5vh 3vw;
    background-color: #E2A9A1;
  
`;

export function LabTenC() {
    return(
        <>
            <StyledHeader>
                <h1>My Second React App</h1>
                <p>This is Jiaqi's 2nd React App</p>
            </StyledHeader>
            <StyledMain>
                <h3>Recent Favorite Restaurants</h3>
                <ol>
                    <li>Laughing Monk Cafe</li>
                    <li>Bonchon Chicken</li>
                    <li>Bar'Cino</li>
                </ol>
            </StyledMain>
        </>)
}
